import React from 'react';
import style from './switch.module.scss';

type Props = {
	checked: boolean;
	onSwitch: (checked: boolean) => void;
	disabled?: boolean;
};

export function Switch(props: Props) {
	const { checked, onSwitch, disabled = false } = props;
	return (
		<button
			disabled={disabled}
			className={style.switch}
			onClick={() => onSwitch(!checked)}
		>
			<div data-checked={checked} className={style.circle} />
		</button>
	);
}
